// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressDetailsPage_wrapper__is7r8"};